import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { IntegrationSyncJob, IntegrationSyncJobCreate, IntegrationSyncJobFilter } from '../data/integrationSyncJob';

export function createIntegrationSyncJobService(client: AxiosInstance) {
  return createCrudService<IntegrationSyncJob, IntegrationSyncJobCreate, IntegrationSyncJobFilter>(
    client,
    '/integration/IntegrationSyncJob',
    'id',
  );
}

export type IntegrationSyncJobService = CrudService<IntegrationSyncJob, IntegrationSyncJobCreate, IntegrationSyncJobFilter>;
